import axios from "axios";

const BASE_URL = "https://praneeshinfotech.com/kongudevapi/api";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  },
});

// Get all subscription payment transactions for logged-in branch
export const getPaymentTransactions = (params = {}) => {
  return axios.get(`${BASE_URL}/subscriptions`, {
    ...getConfig(),
    params,
  });
};